import React from 'react';
import { GraduationCap, ArrowRight } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function GradebookStep({ programmeId, programme, token, headers }) {
  const navigate = useNavigate();

  if (!programmeId) {
    return (
      <div className="text-center py-12">
        <GraduationCap className="h-12 w-12 text-zinc-600 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-white mb-2">Save Programme First</h3>
        <p className="text-zinc-400">Complete Step 1 to access gradebook</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="p-4 bg-emerald-500/10 rounded-lg border border-emerald-500/30">
        <p className="text-sm text-emerald-300">
          The gradebook automatically includes all enrolled learners from Step 2. 
          Grade Portfolio of Evidence (POE) submissions and track overall learner grades.
        </p>
      </div>

      <div className="text-center py-8">
        <GraduationCap className="h-16 w-16 text-emerald-400 mx-auto mb-4" />
        <h3 className="text-xl font-semibold text-white mb-2">Programme Gradebook</h3>
        <p className="text-zinc-400 mb-6 max-w-md mx-auto">
          Review and grade learner submissions, view POE uploads, and manage overall programme grades. 
          Learner list is automatically populated from enrollments.
        </p>
        <Button
          onClick={() => navigate(`/admin/programmes/${programmeId}/gradebook`)}
          className="bg-emerald-600 hover:bg-emerald-700 text-white"
        >
          Open Gradebook
          <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </div>
    </div>
  );
}
